export const initialState = {
	companies: [],
	isLoadingCompanies: false,
	isLoadedCompanies: false,
	hasLoadingErrorCompanies: false
};

export default initialState;
